import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import ECharts from '~/components/echarts'
import { organizationAWSRDSOptimizationRightSizeRecommendationCpuChartPath } from '~/routes'

export default function AwsRdsCpuRightSizeRecommendationsCharts({
  organizationId: orgId,
  resourceId: reId,
  optimizationId: optId,
}) {
  const params = { metrics_time_frame: '1w' }

  const RDSCpuChartUrl = useMemo(
    () => organizationAWSRDSOptimizationRightSizeRecommendationCpuChartPath(orgId, optId, reId),
    [orgId, optId, reId],
  )
  return (
    <div className='card'>
      <div className='card-body'>
        <div className='row g-0'>
          <div className='col-sm-12'>
            <ECharts
              title={t`CPU Utilization`}
              chartInfoTitle='aws_rds_recommendations_cpu_utilization'
              url={RDSCpuChartUrl}
              params={params}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
